export class Token {
	accessToken: string;
	expiresIn: number;
	scope: string;
	state: string;
	tokenType: string;
	expiresAt: Date;
	refreshToken: string;

	constructor(token?: any) {
		let t = token || {};
		this.accessToken = t.accessToken || '';
		this.expiresIn = t.expiresIn || 0;
		this.scope = t.scope || '';
		this.state = t.state || '';
		this.tokenType = t.tokenType || '';
		this.expiresAt = new Date(t.expiresAt) || new Date();
		this.refreshToken = t.refreshToken || '';
	}
}
